(function () {
  const options = {
    threshold: 0,
    rootMargin: '0px 0px 0px 0px'
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const el = entry.target;

      if (entry.isIntersecting) {
        if (el.classList.contains('once')) {
          if (!el.classList.contains('has-intersected')) {
            el.classList.add('active');
            el.classList.add('has-intersected');
          }
        } else {
          el.classList.add('active');
        }
      } else {
        el.classList.remove('active');

        if (el.classList.contains('once') && el.classList.contains('has-intersected')) {
          observer.unobserve(el);
        }
      }
    });
  }, options);

  const elements = document.querySelectorAll('.intersect');
  elements.forEach(el => observer.observe(el));
})();
